import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import FormContainer from "../../components/FormContainer";
import { toast } from "react-toastify";
import { useGetUserQuery , useUpdateUserMutation } from "../../slices/usersApiSlice";

const UserEditScreen = () => {
  const {id: userId} = useParams();
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('0');
  const [password, setPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  const { data: user, isLoading, error, refetch} = useGetUserQuery(userId);

  const [updateUser, {isLoading: isLoadingUpdateUser}] = useUpdateUserMutation();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setPhone(user.phone);
      setPassword(user.password);
      setIsAdmin(user.isAdmin);
    }
  }, [user]);

  const submitHandler = async (e) => {
    e.preventDefault();
    const updatedUser = {
      _id: userId,
      name,
      email,
      phone,
      password,
      isAdmin
    };

    const result = await updateUser(updatedUser);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("User updated");
      navigate("/admin/userlist");
      refetch();
    }
  };

  return (
    <>
      <Link to='/admin/userlist' className='btn btn-light my-3'>Back</Link>
      <FormContainer>
        <h1>Edit User</h1>
        { isLoadingUpdateUser && <Loader/> }
        { isLoading ? <Loader/> : error ? <Message variant="danger">{error}</Message> : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="name" className="my-2">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="email" className="my-2">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="phone" className="my-2">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="password" className="my-2">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="isAdmin" className="my-2">
              <Form.Label>Is Admin</Form.Label>
              <Form.Check
                type="checkbox"
                id="isAdmin"
                checked={isAdmin ? true : false}
                onChange={(e) => {setIsAdmin(e.target.checked)}}>
              </Form.Check>
            </Form.Group>
            <Button type="submit" variant="primary" className="my-2">
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  )
}

export default UserEditScreen